import React from "react";
import { Link } from "react-router-dom";
import {
  Home,
  ShieldAlert
} from "lucide-react";

import Navigation from "../components/Navigation";
import FooterSection from "../components/FooterSection";
import "./NotFound.css";

const NotFound = () => {
  return (
    <div className="nf-portal">
      <Navigation />
      {/* Background Effects */}
      <div className="nf-grid-field"></div>
      <div className="nf-scanline"></div>

      <main className="nf-main">
        <div className="nf-glitch-wrapper">
          <div className="nf-error-code">404</div>
        </div>

        <h1 className="nf-title">
          Page <span className="text-gradient">Not Found</span>
        </h1>

        <p className="nf-subtitle">
          The page you are looking for does not exist or has been moved.
        </p>

        <div className="nf-bypass-controls">
          <Link to="/">
            <button className="nf-btn primary">
              <Home size={18} />
              Go to Home
            </button>
          </Link>

          <Link to="/help">
            <button className="nf-btn">
              <ShieldAlert size={18} />
              Get Help
            </button>
          </Link>
        </div>
      </main>

      <FooterSection />
    </div>
  );
};

export default NotFound;